import React from 'react';
import './Headertrans.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche

function Headertrans() {
  return (
    
      <div className='main13'>
        
            
        <div className="boutton-container13">
            <div className='butT'>
            <button className="boutton13">ETAT-CIVIL<ArrowForwardIcon className="arrow-icon1" />TRANSCRIPTION</button>
         <h1>TRANSCRIPTION</h1> 
        </div>
        </div>
    </div>
   
  );
}

export default Headertrans;
